exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yf_8XajjQlgzvhc9C5DwS{font-size:16px}html[dir=ltr] .yf_8XajjQlgzvhc9C5DwS{padding-left:0}html[dir=rtl] .yf_8XajjQlgzvhc9C5DwS{padding-right:0}", ""]);

// exports
exports.locals = {
	"star": "yf_8XajjQlgzvhc9C5DwS"
};